// Photos panel for a call-out (Session W Item 2). The office Call-outs page is a list,
// so this opens a modal showing the photos taken on the call-out's completed job via
// the shared JobPhotoGallery (images load through the authenticated office proxy; the
// raw Drive URLs never reach the browser). Shows a plain empty state when none exist.
import { useEffect, useState } from "react";
import { Loader } from "../../components/Loader";
import { ModalShell } from "../../components/ModalShell";
import { api } from "../../lib/api";
import type { CalloutDetail, CalloutListItem } from "../../lib/api";
import { JobPhotoGallery } from "./JobPhotoGallery";

export function CalloutPhotosModal({ callout, onClose }: { callout: CalloutListItem; onClose: () => void }) {
  const [detail, setDetail] = useState<CalloutDetail | null>(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    let live = true;
    api.callouts
      .get(callout.id)
      .then((d) => {
        if (live) setDetail(d);
      })
      .catch(() => {
        if (live) setError(true);
      });
    return () => {
      live = false;
    };
  }, [callout.id]);

  return (
    <ModalShell ariaLabel={`Photos for ${callout.ref}`} onClose={onClose} width="max-w-[560px]" panelClassName="max-h-[90vh] overflow-y-auto p-6">
        <div className="mb-4 flex items-start justify-between gap-3">
          <h2 className="font-heading text-xl text-ele-strong">
            Photos: {callout.ref}
            {callout.siteName ? `, ${callout.siteName}` : ""}
          </h2>
          <button type="button" onClick={onClose} className="rounded-ele border border-ele-purple-accent px-3 py-1.5 text-sm">Close</button>
        </div>

        {error ? (
          <p role="alert" className="rounded-ele border border-ele-danger bg-ele-surface p-4 text-sm text-ele-strong">
            Could not load the photos. Please try again in a moment.
          </p>
        ) : detail === null ? (
          <Loader shape="inline" />
        ) : detail.jobId == null ? (
          <p className="rounded-ele border border-ele-purple-accent bg-ele-surface p-6 text-center text-ele-body">No photos recorded for this job.</p>
        ) : (
          <JobPhotoGallery jobId={detail.jobId} count={detail.photoCount} label="" emptyText="No photos recorded for this job." />
        )}
    </ModalShell>
  );
}
